import React from 'react';

/**
 * StatCard: flat bordered card with an overline label and a large value.
 * Used on Feature_Home and Analyze. Light theme only.
 */
export interface StatCardProps {
  label: string;
  value: React.ReactNode;
  /** Short supporting line under the value. */
  hint?: React.ReactNode;
  /** Optional lucide-react icon shown beside the label. */
  icon?: React.ReactNode;
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  hint,
  icon,
  className = '',
}) => (
  <div
    className={`rounded-xl border border-gray-200 bg-white p-4 ${className}`.trim()}
  >
    <div className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.1em] text-gray-500">
      {icon}
      <span>{label}</span>
    </div>
    <div className="mt-1.5 text-[28px] font-bold leading-tight text-gray-900">{value}</div>
    {hint ? <div className="mt-1 text-xs text-gray-600">{hint}</div> : null}
  </div>
);

export default StatCard;
